// useTemplates.js
import { useEffect, useState, useCallback } from 'react';
import { getTemplates } from 'services/fileManager/fileManagerServices';

export function useTemplatesList(initialParams = '') {
  const [templateListOptions, setTemplateListOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTemplates = useCallback(
    async (params = initialParams) => {
      setLoading(true);
      setError(null);
      try {
        const response = await getTemplates(params);
        const arr = response.data?.data || [];
        const templates = arr.map((item) => ({
          label: item.display_name,
          value: `${item.pk} ${item.sk}`,
        }));
        setTemplateListOptions(templates);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [initialParams]
  );

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  return {
    templateListOptions,
    loading,
    error,
    refetch: fetchTemplates,
  };
}
